// extracted by mini-css-extract-plugin
module.exports = {"contentHolder":"TeacherProfile_contentHolder__2GhUN","contentHolderLeft":"TeacherProfile_contentHolderLeft__Deaff","form":"TeacherProfile_form__1o1qv"};